module.exports = __webpack_public_path__ + "media/MRI7A.825641b7.mp3";